// src/views/words-lists/components/CreateFolderModal.tsx
import React, { FC } from 'react';
import { Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import AppModal, { ModalButtons } from '../../../components/AppModal';
import styles from '../FolderTreeView.module.less';

interface CreateFolderModalProps {
  visible: boolean;
  parentId: string | null;
  name: string;
  isCreating: boolean;
  onNameChange: (name: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
}

export const CreateFolderModal: FC<CreateFolderModalProps> = ({
  visible,
  parentId,
  name,
  isCreating,
  onNameChange,
  onCancel,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <AppModal
      title={parentId ? t('folders:createFolder.titleSub') : t('folders:createFolder.title')}
      visible={visible}
      onCancel={onCancel}
    >
      <Input
        placeholder={t('folders:createFolder.placeholder')}
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        onPressEnter={onSubmit}
        autoFocus
        maxLength={255}
        className={styles.folderModalInput}
      />
      <ModalButtons>
        <Button onClick={onCancel}>
          {t('common:buttons.cancel')}
        </Button>
        <Button
          type="primary"
          onClick={onSubmit}
          loading={isCreating}
        >
          {t('common:buttons.create')}
        </Button>
      </ModalButtons>
    </AppModal>
  );
};
